var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7966 2.80059L9.95402 0.957975V5.87161H14.8677L13.025 4.029L15.7807 1.27333L14.5523 0.0449219L11.7966 2.80059ZM1.88075 0.0449219L0.652344 1.27333L3.40801 4.029L1.5654 5.87161H6.47903V0.957975L4.63642 2.80059L1.88075 0.0449219ZM14.8677 9.3466H9.95402V14.2602L11.7966 12.4176L14.5523 15.1733L15.7807 13.9449L13.025 11.1892L14.8677 9.3466ZM3.40801 11.1892L0.652344 13.9449L1.88075 15.1733L4.63642 12.4176L6.47903 14.2602V9.3466H1.5654L3.40801 11.1892Z",
    fill: "#404041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullScreen);
export default __webpack_public_path__ + "static/media/ExitFullScreen.cc3aeec4edc313d27c57609410360b06.svg";
export { ForwardRef as ReactComponent };